//
// Configuración
//
import Style from 'ol/style/Style';
import Icon from 'ol/style/Icon';
import { Vector as VectorSource } from 'ol/source';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import CircleStyle from 'ol/style/Circle';
import imagenVerde from '../imgs/ubicacionVerde.png';
import imagenRojo from '../imgs/ubicacionRojo.png';

export const urlGeoportal = 'https://icts-donana.es/geoportal',
urlWMSInundaciones= 'https://icts-donana.es/geoserver/inundacionv1/wms?',
urlWMSLastebd= 'https://icts-donana.es/geoserver/lastebd/wms?',
urlWMSHidroperiodo= 'https://icts-donana.es/geoserver/hidroperiodov1/wms?',
proyeccion3857= 'EPSG:3857',
proyeccion4326= 'EPSG:4326',
proyeccion25829= 'EPSG:25829',
proyeccion25830= 'EPSG:25830',
centroide3857= [-713763.2300692879,4436845.378786967],
extension3857= [-756847.7348399286,4409021.946455098,-685925.6514828257,4486502.344182203],
formatoPNG= 'image/png',
versionWMS= '1.3.0',
versionWFS= '1.1.0',
exepcion= 'application/vnd.ogc.se_inimage',
formatoSalidaJson= 'application/json',
formatoSalidaGeoJson= 'application/geojson',
formatoTexto= 'text/plain',
fuente= new VectorSource({ wrapX: false, projection: proyeccion3857}),
nombresColumnas= [
  {id: 'Value_Pixel', nombre: 'Inundado'},
  {id: 'GRAY_INDEX', nombre:  'Inundado'},
  {id: 'NOMBRE', nombre: 'Nombre'},
  {id: 'ATRIBUTO', nombre: 'Nombre'},
  {id: 'ID_UNIQUE', nombre: 'Código'},

  {id: 'Fecha', nombre: 'Fecha'},
  {id: 'AREAE', nombre: 'Área(m2)'},
  {id: 'Shape_Area', nombre: 'Área(m2)'},
  {id: 'LUGAR', nombre: 'Lugar'},
  {id: 'sup_ha', nombre: 'Área(ha)'},


  {id: 'LOCALIDAD', nombre: 'Localidad'},
  {id: 'LOC_24', nombre: 'Loc_24'},
  {id: 'LOC_4', nombre: 'Loc_4'},
  {id: 'parcela', nombre: 'Nombre'},

],
estilosDibujo = {
  Point: new Style({
    image: new CircleStyle({
      radius: 5,
      fill: new Fill({ color: 'red' }),
    }),
  }),
  LineString: new Style({
    stroke: new Stroke({
      color: 'yellow',
      width: 2,
    }),
  }),
  Polygon: new Style({
    stroke: new Stroke({
      color: 'yellow',
      width: 2,
    }),
    fill: new Fill({
      color: 'blue',
    }),
  }),
  Circle: new Style({
    stroke: new Stroke({
      color: 'blue',
      width: 2,
    }),
    fill: new Fill({
      color: 'yellow',
    }),
  }),
},
estiloMarcadorVerde= new Style({
  image: new Icon({
      anchor: [0.2, 20],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      src: imagenVerde,
  })
}),
estiloMarcadorRojo= new Style({
  image: new Icon({
      anchor: [0.2, 20],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      src: imagenRojo,
  })
});

export function fechaHoy()
{
  const fecha = new Date(),
  dia = String(fecha.getDate()).padStart(2, '0'),
  mes = String(fecha.getMonth() + 1).padStart(2, '0'),
  año = fecha.getFullYear();
  return (dia + '' + mes + '' + año);
}

export function mensaje(id, mensaje, tipo)
{
  const alertPlaceholder = document.getElementById(id);
  const texto = '<div class="alert alert-'+ tipo + ' alert-dismissible py-1 px-2" role="alert">' +
    ' <div>'+ mensaje +'</div>' +
    ' <button type="button" class="btn-close btn-close-sm" data-bs-dismiss="alert" aria-label="Close" style="transform: scale(0.8);"></button>' +
    '</div>';
  alertPlaceholder.innerHTML = texto;
}

export function validarURLServicioWMS(url) {
  const regex = /[?&](?=.*\brequest\b)(?=.*\bservice\b)/i;
  return regex.test(url);
}

export function modificarURLServicioWMS(url) {
  if (!/\?/.test(url) || !/(?:[?&])(REQUEST|SERVICE)=/i.test(url)) {
    const parametrosFaltantes = [];

    if (!/(?:[?&])REQUEST=/i.test(url)) {
      parametrosFaltantes.push('REQUEST=GetCapabilities');
    }
    if (!/(?:[?&])SERVICE=/i.test(url)) {
      parametrosFaltantes.push('SERVICE=WMS');
    }

    url += (url.includes('?') ? '&' : '?') + parametrosFaltantes.join('&');
  }
  return url;
}

export function validarUrl(url) {
  try {
    new URL(url);
    return true;
  } catch (error) {
    return false;
  }
}

export function obtenerSRID(srid) {
  switch (srid) {
      case '25829':
      return proyeccion25829;
      case '25830':
      return proyeccion25830;
      case '4326':
      return proyeccion4326;      
  }
}